import { render } from "./Delivery.vue?vue&type=template&id=2f2c392a&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"

import "./Delivery.vue?vue&type=style&index=0&id=2f2c392a&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2c392a"]])

export default __exports__